export enum AppEnvironment {
  Unknown = 0,
  Development = 1,
  Testing = 2,
  Staging = 3,
  Production = 4
}
